module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    class: ['controls-list']
  }, [_c('ul', _vm._l((_vm.configurator), function(option, index) {
    return _c('li', {
      key: index
    }, [_c('label', {
      class: [option.disabled ? 'disabled' : null],
      attrs: {
        "for": option.label
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(option.label)
      }
    }), _vm._v(" "), _c('span', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.model),
        expression: "option.model"
      }],
      attrs: {
        "id": option.label,
        "disabled": option.disabled
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(option, "model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_vm._l((option.items), function(item) {
      return (option.colorPicker) ? _c('option', {
        domProps: {
          "value": item,
          "innerHTML": _vm._s(item)
        }
      }) : _vm._e()
    }), _vm._v(" "), _vm._l((option.items), function(item) {
      return _c('option', {
        attrs: {
          "e-else": ""
        },
        domProps: {
          "value": item,
          "innerHTML": _vm._s(item)
        }
      })
    })], 2), _vm._v(" "), (option.colorPicker) ? _c('color', {
      attrs: {
        "background": option.model
      }
    }) : _vm._e()], 1)])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78238865","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demo-components/controls-list.vue
// module id = 50
// module chunks = 0